import { MetaType, BranchMap } from "../types"
import {
  actionCreatorGuard,
  reducerGuard,
  reducerActions,
  getArrayReducerGuard
} from "../reducers"

export const kind = "snap_shots"

export type SnapShot = {
  kind: typeof kind
  version: number
  name: string
  release: string
  branches: BranchMap
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<SnapShot, MetaType>("meta", kind),
  branches: actionCreatorGuard<SnapShot, BranchMap>("branches", kind),
  release: actionCreatorGuard<SnapShot, string>("release", kind),
  name: actionCreatorGuard<SnapShot, string>("name", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    SnapShot,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const snapShotAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const snapShotReducer = reducerGuard<SnapShot>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.branches)
  .case(...reducerAction.release)
  .case(...reducerAction.name)
  .build()
